/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductCodesRequest } from "../models/ProductCodesRequest";
import type { ProductDetailsForBackOfficeResponse } from "../models/ProductDetailsForBackOfficeResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class ProductDetailsService {
  /**
   * Get product details by product codes
   * @param requestBody
   * @returns ProductDetailsForBackOfficeResponse OK
   * @throws ApiError
   */
  public static getProductDetailsForBackOffice(
    requestBody: ProductCodesRequest
  ): CancelablePromise<ProductDetailsForBackOfficeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/internal-service-api/products/",
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
